class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');

    new IntersectionObserver(
      this.handleIntersection.bind(this)
    ).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        const miniCart = document.getElementById('mini-cart');

        if (!miniCart) return;

        miniCart.innerHTML =
          this.getSectionInnerHTML(
            html,
            '.shopify-section'
          );

        document.dispatchEvent(
          new CustomEvent('cartdrawer:opened')
        );
      })
      .catch(error => {
        console.error('[Mielux Mini Cart]', error);
      });
  }

  open() {
    if (!this.drawer) return;

    const detailsElement =
      this.drawer.querySelector('details');

    if (
      detailsElement &&
      detailsElement.hasAttribute('open')
    ) {
      return;
    }

    if (
      typeof this.drawer.openMenuDrawer === 'function'
    ) {
      this.drawer.openMenuDrawer();
    }
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach(section => {
      const element =
        document.getElementById(section.id);

      if (
        element &&
        parsedState.sections &&
        parsedState.sections[section.id]
      ) {
        element.innerHTML =
          this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
      }
    });

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    const documentHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const element =
      documentHTML.querySelector(selector);

    return element ? element.innerHTML : '';
  }
}


/*
 * MIELUX MINI CART REMOVE FIX
 * Works even after AJAX cart refreshes.
 */
(function () {
  if (window.__mieluxCartRemoveInstalled) return;

  window.__mieluxCartRemoveInstalled = true;

  async function refreshMiniCart() {
    const currentURL =
      new URL(window.location.href);

    currentURL.searchParams.set(
      'sections',
      'mini-cart,cart-icon-bubble,mobile-cart-icon-bubble'
    );

    const response = await fetch(
      currentURL.toString(),
      {
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        'Unable to refresh mini cart'
      );
    }

    const sections = await response.json();

    const parser = new DOMParser();

    [
      'mini-cart',
      'cart-icon-bubble',
      'mobile-cart-icon-bubble'
    ].forEach(id => {
      const current =
        document.getElementById(id);

      const sectionHTML =
        sections[id];

      if (!current || !sectionHTML) return;

      const parsed =
        parser.parseFromString(
          sectionHTML,
          'text/html'
        );

      const freshSection =
        parsed.querySelector(
          '.shopify-section'
        );

      if (!freshSection) return;

      current.innerHTML =
        freshSection.innerHTML;
    });

    document.dispatchEvent(
      new CustomEvent(
        'cart:updated',
        {
          bubbles: true
        }
      )
    );

    document.dispatchEvent(
      new CustomEvent(
        'cartdrawer:opened',
        {
          bubbles: true
        }
      )
    );
  }


  document.addEventListener(
    'click',
    async function (event) {
      if (!(event.target instanceof Element)) {
        return;
      }

      const removeButton =
        event.target.closest(
          '[data-mielux-remove-line]'
        );

      if (!removeButton) return;

      const miniCart =
        removeButton.closest(
          '#mini-cart'
        );

      if (!miniCart) return;

      /*
       * Prevent the theme's native
       * cart-remove-button from also firing.
       */
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (removeButton.disabled) return;

      const line = parseInt(
        removeButton.getAttribute(
          'data-mielux-remove-line'
        ),
        10
      );

      if (!line || line < 1) {
        console.error(
          '[Mielux Cart] Invalid line:',
          line
        );

        return;
      }

      removeButton.disabled = true;
      removeButton.setAttribute(
        'aria-busy',
        'true'
      );

      try {
        const root =
          (
            window.Shopify &&
            window.Shopify.routes &&
            window.Shopify.routes.root
          ) || '/';

        const response = await fetch(
          root + 'cart/change.js',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body: JSON.stringify({
              line: line,
              quantity: 0
            })
          }
        );

        if (!response.ok) {
          throw new Error(
            'Shopify could not remove the item'
          );
        }

        await response.json();

        await refreshMiniCart();
      } catch (error) {
        console.error(
          '[Mielux Cart Remove]',
          error
        );

        removeButton.disabled = false;

        removeButton.removeAttribute(
          'aria-busy'
        );
      }
    },
    true
  );
})();


/*
 * Avoid an error if global.js
 * already registered mini-cart.
 */
if (!customElements.get('mini-cart')) {
  customElements.define(
    'mini-cart',
    MiniCart
  );
}